// extracted by mini-css-extract-plugin
module.exports = {"content":"WordPost_content__Xfe_z","relatedWords":"WordPost_relatedWords__n83JP","keyWords":"WordPost_keyWords__NDVZp"};